<template>
  <div v-if="show">
    <div id="time" class="align-left" v-if="displayTimeUI">
      <div class="bg--red font-color-white font-size-14 inline-block padding-horizontal-2x padding-vertical-1x">
        <b>{{ customPrefixedText }}</b><span v-if="customPrefixedText != ''"> --> </span><template v-if="start"><b>Start</b>: {{start}}</template><template v-if="end"><template v-if="start && end">, </template><b>End</b>: {{end}}</template><template v-if="restart">, <b>Restart</b>: {{restart}}</template>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    start: {
      type: String
    },
    end: {
      type: String
    },
    restart: {
      type: String
    },
    dev: {
      type: Boolean,
      default: false
    },
    qa: {
      type: Boolean,
      default: false
    },
    customPrefixedText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    getQueryString: function (name) {
      let match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search)
      return match && decodeURIComponent(match[1].replace(/\+/g, ' '))
    }
  },
  computed: {
    previewMode () {
      if (this.getQueryString('previewmode') !== null) {
        return true
      } else {
        return false
      }
    },
    urlVisible () {
      switch (true) {
        case (window.location.href.indexOf('localhost') > -1):
          return true
        case (window.location.href.indexOf('qa') > -1):
          return true
        case (window.location.href.indexOf('dev') > -1):
          return true
        default:
          return false
      }
    },
    displayTimeUI () {
      if (this.previewMode === true) {
        return true
      } else if (this.qa && this.urlVisible) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    if (this.qa === true && this.urlVisible) {
      this.show = true
    } else if (this.previewMode === true) {
      this.show = true
    } else {
      const now = this.$moment(new Date()).format()
      const start = this.$moment(new Date(this.start)).format()
      const restart = this.$moment(new Date(this.restart)).format()
      const end = this.$moment(new Date(this.end)).format()

      if ((now >= start && now <= end)) {
        this.show = true
      } else if (now >= start && !this.end) {
        console.log(now, start)
        this.show = true
      } else if (!this.start && now <= end) {
        this.show = true
      } else if (now >= restart && now >= end) {
        this.show = true
      } else {
        this.show = false
      }
    }
  }
}
</script>
